import React, { createContext, useContext, useEffect, useState } from 'react';
import Loading from '../../components/Loding/Loading';

const UIContext = createContext();

export const UIProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [RoleUser, setRoleUser] = useState("");
  const [page, setPage] = useState(1);
  const [keyWordSearch, setKeyWordSearch] = useState('');
  const [locationsId, setLocationsId] = useState('');
  const [swapp, setSwapp] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [flag, setFlag] = useState(0);
  const [types, setTypes] = useState('');
  const [typeFlag, setTypeFlag] = useState(false);
  const [statistic, setStatistic] = useState([]);
  const [statusE, setStatusE] = useState('');
  const [subjects, setSubjects] = useState('');
  const [SearchResult, setSearchResult] = useState();
  const [pageComprehensiveRules, setPageComprehensiveRules] = useState(1);
  const [pageList, setPageList] = useState(0);
  const [sectionID, setSectionID] = useState(0);
  const [subId, setSubID] = useState(0);
  const [pageListCount, setPageListCount] = useState(0);
  const [ParenIDForDropDown, setParenIDForDropDown] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [savePage, setSavePage] = useState(1);
  const [showWithID, setShowWithID] = useState(false);
  const [localState, setLocalState] = useState({
    MoreViewLaw: false,
    MoreViewRegulations: false,
    MoreViewVotes: false,
    MoreViewOpinions: false,
    NewTabLaw: true,
    NewTabRegulations: true,
    NewTabVotes: true,
    NewTabOpinions: true,
  });

  const [newInfo, setNewInfo] = useState({
    title: '',
    parentID: null,
    definition: '',
    ordering: 0,
    subjectType: 4,
    keywords: '',
    isPublic: true,
  });

  if (loading) {
    <Loading />;
  }

  const getLocalStorager = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      let list = localStorage.getItem('list');
      if (list && list !== `undefined`) {
        return JSON.parse(localStorage.getItem('list'));
      } else {
        return [];
      }
    }
  };

  const [advSearchState, setAdvSearchState] = useState({
    keyWordSearch: '',
    statusE: '',
    subjects: '',
    locationsId: '',
    searchContent: 2,
    pageSizeAdvance: 10,
    partOfWord: false,
    daaate: '',
    toDaaate: '',
    ApproveDate: '',
    toApproveDate: '',
    checkedSinoname: false,
    checkedNewType: [],
    expandedNewType: [],
    orgs: '',
    orgsId: '',
    checkedTypes: [true, true, true, true],
    valueSelector: 0,
    checkedAF: [true, true],
    checkedJostojoEbarat: [true, true],
    selectedOptionDataOrgs: null,
    selectedOptionDataOrgsID: null,
    isOrder: 0,
    isRepealed: false,
    lawTypeIds: '8,12,15',
    types: '1',
  });

  useEffect(() => {
    setSearchResult(getLocalStorager);
  }, []);
  const [EditDraftComperhensiveLaw, setEditDraftComperhensiveLaw] = useState({
    sectionsAndChaptersId: 0,
    IdSubject: 0,
    reIdSubject: [],
    sectionid: 0,
    oldSubjectId: 0,
    oldChapterId: 0,
  });

  //setSearchResult(getLocalStorager);

  return (
    <UIContext.Provider
      value={{
        loading,
        setLoading,
        keyWordSearch,
        setKeyWordSearch,
        swapp,
        setSwapp,
        modalVisible,
        setModalVisible,
        locationsId,
        setLocationsId,
        statusE,
        setStatusE,
        page,
        setPage,
        flag,
        setFlag,
        types,
        setTypes,
        typeFlag,
        setTypeFlag,
        statistic,
        setStatistic,
        subjects,
        setSubjects,
        SearchResult,
        setSearchResult,
        subId,
        setSubID,
        pageListCount,
        setPageListCount,
        pageCount,
        setPageCount,
        savePage,
        setSavePage,
        localState,
        setLocalState,
        newInfo,
        setNewInfo,
        pageComprehensiveRules,
        setPageComprehensiveRules,
        setPageList,
        pageList,
        sectionID,
        setSectionID,
        EditDraftComperhensiveLaw,
        setEditDraftComperhensiveLaw,
        ParenIDForDropDown,
        setParenIDForDropDown,
        showWithID,
        setShowWithID,
        advSearchState,
        setAdvSearchState,RoleUser, setRoleUser
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export const useUIContext = () => useContext(UIContext);
